'use client';

import Axios from 'axios';
import Cookies from 'js-cookie';

// Auth token
const authToken = 'auth.token';

export const getToken = () =>
    typeof window !== 'undefined' ? localStorage.getItem(authToken) : null;

export const setToken = (
    token: string,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _redirect: string | undefined | null = null,
) => {
    if (typeof window == 'undefined') return;

    localStorage.setItem(authToken, token);

    if (getUrlParams().get('token')) {
        location.href = '/redactie';
    }
};

export const deleteToken = (redirect = null) => {
    if (getToken() != null) {
        setTimeout(() => {
            if (getToken() != null) {
                localStorage.removeItem(authToken);
                if (getUrlParams().get('token')) return;
                if (redirect) {
                    location.href = redirect;
                } else {
                    location.href = '/redactie';
                }
            }
        }, 1000);
    }
};

const axios = (() => {
    const apiUrlBase =
        typeof window !== 'undefined'
            ? process.env.API_URL
            : process.env.INTERNAL_API_URL;

    const usedToken = getToken();

    const a = Axios.create({
        baseURL: `${apiUrlBase}`,
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            Authorization: `Bearer ${usedToken}`,
            Accept: 'application/json',
        },
        withCredentials: true,
        withXSRFToken: true,
        xsrfCookieName: 'XSRF-TOKEN',
        xsrfHeaderName: 'X-XSRF-TOKEN',
        validateStatus: (status) => {
            if (status === 403) location.reload();
            if (status === 401) {
                if (!!usedToken && usedToken === getToken()) {
                    deleteToken();
                }
            }
            if (status === 419) {
                // Request new CSRF token
                a.get('/csrf-cookie');
            }
            return status >= 200 && status < 300;
        },
    });

    // Add a request interceptor to create the CSRF token, if missing
    a.interceptors.request.use(async (config) => {
        // If http method is `post | put | delete` and XSRF-TOKEN cookie is
        // not present, call '/sanctum/csrf-cookie' to set CSRF token, then
        // proceed with the initial response
        if (
            (config.method == 'post' ||
                config.method == 'put' ||
                config.method == 'delete') &&
            !Cookies.get('XSRF-TOKEN')
        ) {
            await a.get('/csrf-cookie').then(() => config);
        }

        return config;
    });

    return a;
})();

export default axios;

// Get form data from object
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getFormData = (object: Record<string, any>) =>
    Object.keys(object).reduce((formData, key) => {
        if (
            !!object[key] &&
            typeof object[key] === 'object' &&
            !(object[key] instanceof File)
        ) {
            for (let i = 0; i < object[key].length; i++) {
                formData.append(`${key}[]`, object[key][i]);
            }
        } else if (object[key] !== undefined) {
            formData.append(key, object[key]);
        }
        return formData;
    }, new FormData());

// Get url params
export const getUrlParams = () => {
    const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop: string) => searchParams.get(prop),
    });

    return {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        get: (name: string) => params[name],
    };
};
